export interface ChartSizeOption {
  title: string;
  sharpCharts2Id: string;
  width: number;
  height: number;
  isPayingMemberOnly: boolean;
  isProOnly: boolean;
};

export const CHART_SIZE_MENU_OPTION_THREE_HUNDRED_SIXTY: ChartSizeOption = {
  title: '360',
  sharpCharts2Id: '360',
  width: 360,
  height: 226,
  isPayingMemberOnly: false,
  isProOnly: false
};

export const CHART_SIZE_MENU_OPTION_FOUR_HUNDRED_SIXTY: ChartSizeOption = {
  title: '460',
  sharpCharts2Id: '460',
  width: 460,
  height: 284,
  isPayingMemberOnly: false,
  isProOnly: false
};

export const CHART_SIZE_MENU_OPTION_FIVE_HUNDRED_TWENTY: ChartSizeOption = {
  title: '520',
  sharpCharts2Id: '520',
  width: 520,
  height: 318,
  isPayingMemberOnly: false,
  isProOnly: false
};

export const CHART_SIZE_MENU_OPTION_SIX_HUNDRED_TWENTY: ChartSizeOption = {
  title: '620',
  sharpCharts2Id: '620',
  width: 620,
  height: 376,
  isPayingMemberOnly: false,
  isProOnly: false
};

export const CHART_SIZE_MENU_OPTION_SEVEN_HUNDRED: ChartSizeOption = {
  title: '700',
  sharpCharts2Id: '700',
  width: 700,
  height: 312,
  isPayingMemberOnly: false,
  isProOnly: false
};

export const CHART_SIZE_MENU_OPTION_SEVEN_HUNDRED_EIGHTY: ChartSizeOption = {
  title: '780',
  sharpCharts2Id: '780',
  width: 780,
  height: 345,
  isPayingMemberOnly: false,
  isProOnly: false
};

export const CHART_SIZE_MENU_OPTION_NINE_HUNDRED: ChartSizeOption = {
  title: '900',
  sharpCharts2Id: '900',
  width: 900,
  height: 396,
  isPayingMemberOnly: false,
  isProOnly: false
};

export const CHART_SIZE_MENU_OPTION_ONE_THOUSAND_TWENTY_FOUR: ChartSizeOption = {
  title: '1024',
  sharpCharts2Id: '1024',
  width: 990,
  height: 438,
  isPayingMemberOnly: true,
  isProOnly: false
};

export const CHART_SIZE_MENU_OPTION_ONE_THOUSAND_TWO_HUNDRED_EIGHTY: ChartSizeOption = {
  title: '1280',
  sharpCharts2Id: '1280',
  width: 1240,
  height: 546,
  isPayingMemberOnly: true,
  isProOnly: false
};

export const CHART_SIZE_MENU_OPTION_ONE_THOUSAND_FOUR_HUNDRED: ChartSizeOption = {
  title: '1400',
  sharpCharts2Id: '1400',
  width: 1400,
  height: 620,
  isPayingMemberOnly: true,
  isProOnly: false
};

export const CHART_SIZE_MENU_OPTION_ONE_THOUSAND_FIVE_HUNDRED: ChartSizeOption = {
  title: '1500',
  sharpCharts2Id: '1500',
  width: 1500,
  height: 664,
  isPayingMemberOnly: true,
  isProOnly: false
};

export const CHART_SIZE_MENU_OPTION_ONE_THOUSAND_SIX_HUNDRED: ChartSizeOption = {
  title: '1600',
  sharpCharts2Id: '1600',
  width: 1565,
  height: 681,
  isPayingMemberOnly: true,
  isProOnly: false
};

export const CHART_SIZE_MENU_OPTION_TWO_THOUSAND: ChartSizeOption = {
  title: '2000',
  sharpCharts2Id: '2000',
  width: 2000,
  height: 900,
  isPayingMemberOnly: true,
  isProOnly: true
};

export const CHART_SIZE_MENU_OPTION_TWO_THOUSAND_FIVE_HUNDRED: ChartSizeOption = {
  title: '2500',
  sharpCharts2Id: '2500',
  width: 2500,
  height: 1080,
  isPayingMemberOnly: true,
  isProOnly: true
};

export const CHART_SIZE_MENU_OPTION_PORTRAIT: ChartSizeOption = {
  title: 'Portrait',
  sharpCharts2Id: 'Portrait',
  width: 670,
  height: 838,
  isPayingMemberOnly: false,
  isProOnly: false
};

export const CHART_SIZE_MENU_OPTION_LANDSCAPE: ChartSizeOption = {
  title: 'Landscape',
  sharpCharts2Id: 'Landscape',
  width: 850,
  height: 633,
  isPayingMemberOnly: false,
  isProOnly: false
};

export const CHART_SIZE_MENU_OPTION_CUSTOM: ChartSizeOption = {
  title: 'Custom',
  sharpCharts2Id: 'Custom',
  width: 700,
  height: 312,
  isPayingMemberOnly: true,
  isProOnly: false
};

export const DEFAULT_CHART_SIZE_MENU_OPTION: ChartSizeOption = CHART_SIZE_MENU_OPTION_NINE_HUNDRED;

export const CHART_SIZE_MENU_OPTIONS_ARRAY = [
  CHART_SIZE_MENU_OPTION_THREE_HUNDRED_SIXTY,
  CHART_SIZE_MENU_OPTION_FOUR_HUNDRED_SIXTY,
  CHART_SIZE_MENU_OPTION_FIVE_HUNDRED_TWENTY,
  CHART_SIZE_MENU_OPTION_SIX_HUNDRED_TWENTY,
  CHART_SIZE_MENU_OPTION_SEVEN_HUNDRED,
  CHART_SIZE_MENU_OPTION_SEVEN_HUNDRED_EIGHTY,
  CHART_SIZE_MENU_OPTION_NINE_HUNDRED,
  CHART_SIZE_MENU_OPTION_ONE_THOUSAND_TWENTY_FOUR,
  CHART_SIZE_MENU_OPTION_ONE_THOUSAND_TWO_HUNDRED_EIGHTY,
  CHART_SIZE_MENU_OPTION_ONE_THOUSAND_FOUR_HUNDRED,
  CHART_SIZE_MENU_OPTION_ONE_THOUSAND_FIVE_HUNDRED,
  CHART_SIZE_MENU_OPTION_ONE_THOUSAND_SIX_HUNDRED,
  CHART_SIZE_MENU_OPTION_TWO_THOUSAND,
  CHART_SIZE_MENU_OPTION_TWO_THOUSAND_FIVE_HUNDRED,
  CHART_SIZE_MENU_OPTION_PORTRAIT,
  CHART_SIZE_MENU_OPTION_LANDSCAPE,
  CHART_SIZE_MENU_OPTION_CUSTOM
];

export function getChartSizeObjFromChartSizeTitle(chartSizeTitle: string): ChartSizeOption {
  return CHART_SIZE_MENU_OPTIONS_ARRAY.find(cs => cs.title === chartSizeTitle) ?? DEFAULT_CHART_SIZE_MENU_OPTION;
}
